// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RWxZ","content":"styles_content__3cHNL"};